import primaryButtonDisabled from '../../../../../common/algorithms/primary-button-disabled';

const light = (params) => primaryButtonDisabled(params);

export default light;
